import * as React from 'react'
import cx from 'classnames'
import styles from './json.viewer.styl'
import { getHtmlSelectorValueBy } from '@src/utils/css.selector.helper'
import type { JsonViewerProps, FieldProps } from './models'

const JsonViewer: React.FC<JsonViewerProps> = ({
  children,
  className,
  role
}: React.PropsWithChildren<JsonViewerProps>) => (
  <pre role={role} className={cx(className, styles.jsonViewer)}>
    {children}
  </pre>
)

export const Field: React.FC<FieldProps> = ({
  title,
  children
}: React.PropsWithChildren<FieldProps>) => (
  <p data-role={getHtmlSelectorValueBy(title, 'field_', '_', 'lower')}>
    {title && <label className={styles.bold}>{`${title}:`}</label>}
    <span role="value">{children}</span>
  </p>
)

export default JsonViewer
